<template>
  <div class="course-filter">
    <Select :list="subjects" defaultItemName="学科" @on-change="onSubjectChange" />
    <Select :list="statuses" defaultItemName="状态" @on-change="onStatusChange" />
    <Select :list="times" defaultItemName="时间" @on-change="onTimeChange" />
  </div>
</template>

<script>
import Select from './Select.vue';
export default {
  name: 'MemberStoveCourseFilter',
  components: {
    Select,
  },
  data() {
    return {
      subjects: [],
      times: [],
      statuses: [],
      subject: 0,
      time: 0,
      status: 0,
    };
  },
  mounted() {
    this.getFilterList();
  },
  methods: {
    getFilterList() {
      this.$http.get('/backend-api/app/study/stove/filterEnums').then((data) => {
        let { subjects, times, statuses } = data;
        this.subjects = subjects || [];
        this.times = times || [];
        this.statuses = statuses || [];
      });
    },
    onSubjectChange(item) {
      this.subject = item.value;
      this.search();
    },
    onStatusChange(item) {
      this.status = item.value;
      this.search();
    },
    onTimeChange(item) {
      this.time = item.value;
      this.search();
    },
    search() {
      this.$emit('on-search', {
        subject: this.subject,
        time: this.time,
        status: this.status,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-filter {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
